import { useState } from "react";

import Box from "@mui/material/Box";

import EditIcon from "@mui/icons-material/Edit";

import Dialog from "./Dialog";

const EditButton = ({ userId, companyId }) => {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	return (
		<>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "4px",
					border: "1px solid rgba(224, 224, 224, 1)",
					borderRadius: "4px",
					cursor: "pointer",
					height: "27px",
					width: "27px",
				}}
				onClick={handleClickOpen}
			>
				<EditIcon sx={{ fontSize: "17px" }} />
			</Box>
			<Dialog
				open={open}
				onClose={handleClose}
				userId={userId}
				companyId={companyId}
				skip={!open}
			/>
		</>
	);
};

export default EditButton;
